module.exports = __webpack_public_path__ + "resources/img/ic_warning.b5f2c6b0ac4292937b6d5d4c284ee187.png";